import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import ProductServices from "../../../services/Product";
import { ErrorToaster, SuccessToaster } from "../../components/toaster/Toaster";
import ProductForm from "./productform";

const EditProduct = () => {

  const route = all_routes;
  const navigate = useNavigate();
  const { id } = useParams();

  const [loading, setLoading] = useState(false);

  // *For Update Product
  const updateProduct = async (formData) => {
    setLoading(true)
    try {
      await ProductServices.updateProduct(id, formData)
      SuccessToaster('Update Successfully')
      navigate(route?.products)
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Update Product</h4>
            </div>
          </div>
        </div>
        <ProductForm onSubmit={updateProduct} loading={loading} />
      </div >
    </div >
  );
};

export default EditProduct;
